import {
    FeedPostDropDown,
    PostMedia3,
    PostText,
    PostUserBlock,
    SocialCount
} from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type ThreadSubPostProps = CustomComponentProps & {
    lastThread?: boolean;
};

const ThreadSubPost = ({
    lastThread = false,
    className,
    style
}: ThreadSubPostProps) => {
    return (
        <div className={`card is-post mb-20 mt-20 ${className}`} style={style}>
            {/* <!-- Main wrap --> */}
            <div className={`content-wrap p-relative`}>
                {!lastThread ? <div className="thread-post-v-line"></div> : ""}

                {/* <!-- Post header --> */}
                <div className="card-heading">
                    {/* <!-- User meta --> */}
                    <PostUserBlock />
                    {/* Right side dropdown */}
                    <FeedPostDropDown />
                </div>
                {/* <!-- /Post header --> */}

                {/* <!-- Post body --> */}
                <div className="thread-post-body">
                    <div className="card-body">
                        {/* <!-- Post body text --> */}
                        <PostText text="Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!" />
                        {/* <!-- Featured image --> */}
                        <PostMedia3 />
                    </div>
                    {/* <!-- /Post body --> */}

                    {/* <!-- Post footer --> */}
                    <div className="card-footer">
                        {/* <!-- Post statistics --> */}
                        <SocialCount />
                    </div>
                    {/* <!-- /Post footer --> */}
                </div>
            </div>
            {/* <!-- /Main wrap --> */}
        </div>
    );
};

export default ThreadSubPost;
